import React from 'react'
import { formatDate } from '@/utils/dateFormat'
import { useAuth } from '@/auth/useAuth'
import { PageHeader } from '@/components/ui/PageHeader'
import { ExternalLink } from 'lucide-react'

const Profile: React.FC = () => {
  const { user } = useAuth()

  return (
    <div style={{ padding: '0' }}>
      <PageHeader title="My profile" />

      <div style={{ padding: '24px' }}>
        {/* Profile details card */}
        <div
          style={{
            marginBottom: '24px',
            border: '1px solid var(--color-light-grey)',
            borderRadius: '8px',
            padding: '24px',
            backgroundColor: 'var(--color-white)',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
          }}
        >
          <h2 style={{ fontSize: '16px', fontWeight: 600, margin: '0 0 16px 0', color: 'var(--color-black)' }}>
            Profile details
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '20px' }}>
            {user && [
              { label: 'Display name', value: user.displayName },
              { label: 'Email', value: user.email },
              { label: 'Job title', value: user.jobTitle || '-' },
              { label: 'Department', value: user.department || '-' },
            ].map((field) => (
              <div key={field.label}>
                <div style={{ fontSize: '12px', color: 'var(--color-dark-grey)', marginBottom: '4px', fontWeight: 500 }}>
                  {field.label}
                </div>
                <div style={{ fontSize: '14px', color: 'var(--color-black)' }}>
                  {field.value}
                </div>
              </div>
            ))}
          </div>

          <div style={{ borderTop: '1px solid var(--color-light-grey)', paddingTop: '16px', fontSize: '13px', color: 'var(--color-dark-grey)', marginBottom: '20px' }}>
            <p style={{ margin: '0 0 8px 0' }}>
              Last synced <strong>{user?.lastSyncedAt ? formatDate(user.lastSyncedAt) : 'Never'}</strong>
            </p>
          </div>

          <p style={{ margin: 0, fontSize: '13px', color: 'var(--color-dark-grey)', marginBottom: '16px', lineHeight: '1.5' }}>
            Your profile information is managed in Microsoft 365. Contact your IT team to make changes.
          </p>

          {user?.entraProfileUrl && (
            <a
              href={user.entraProfileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 16px',
                backgroundColor: 'var(--color-magenta)',
                color: 'var(--color-white)',
                textDecoration: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: 500,
                fontFamily: 'var(--font-family)',
              }}
            >
              Edit in Microsoft 365
              <ExternalLink size={16} />
            </a>
          )}
        </div>

        {/* Notification preferences card */}
        <div
          style={{
            border: '1px solid var(--color-light-grey)',
            borderRadius: '8px',
            padding: '24px',
            backgroundColor: 'var(--color-white)',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
          }}
        >
          <h2 style={{ fontSize: '16px', fontWeight: 600, margin: '0 0 16px 0', color: 'var(--color-black)' }}>
            Notification preferences
          </h2>

          <div style={{ padding: '16px', backgroundColor: '#fafafa', borderRadius: '6px', border: '1px solid var(--color-light-grey)' }}>
            <p style={{ margin: 0, fontSize: '14px', color: 'var(--color-dark-grey)', lineHeight: '1.5' }}>
              Notification preferences per app will appear here as apps are added to The Lab.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
